import React from "react";
import { Menu, MenuItem } from "@mui/material";
import { ColumnIcon, DownIcon, UpIcon, VisibilityOff } from "../../../../../../../../assets/icons";
import { GreenrouterColumn, GreenrouterRow } from "../../../../data";

type Props = {
	anchorEl: HTMLElement | null;
	onClose: () => void;
	column?: GreenrouterColumn;
	columns: GreenrouterColumn[];
	visibleCount: number;
	onSort?: (field: keyof GreenrouterRow, direction?: "asc" | "desc") => void;
	onColumnsChange?: (cols: GreenrouterColumn[]) => void;
	setColumnsOpen: (open: boolean) => void;
};

const ColumnMenu = ({
	anchorEl,
	onClose,
	column,
	columns,
	visibleCount,
	onSort,
	onColumnsChange,
	setColumnsOpen,
}: Props) => {

	const open = Boolean(column) && Boolean(anchorEl);

	const hideCurrentColumn = () => {
		if (!column) return;
		if (column.hideable === false) return;
		if (visibleCount === 1) return;

		onColumnsChange?.(columns.map((c) => (c.field === column.field ? { ...c, visible: false } : c)));
		onClose();
	};

	return (
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			disableScrollLock
		>
			<MenuItem onClick={() => column && onSort?.(column.field, "asc")}>
				<UpIcon sx={{ mr: 2 }} /> Sort by ASC
			</MenuItem>
			<MenuItem onClick={() => column && onSort?.(column.field, "desc")}>
				<DownIcon sx={{ mr: 2 }} /> Sort by DESC
			</MenuItem>
			<MenuItem onClick={hideCurrentColumn} disabled={!column || column.hideable === false || visibleCount === 1}>
				<VisibilityOff sx={{ mr: 2 }} />
				Hide column
			</MenuItem>
			<MenuItem
				onClick={() => {
					onClose();
					setColumnsOpen(true);
				}}
			>
				<ColumnIcon sx={{ mr: 2 }} />
				Manage columns
			</MenuItem>
		</Menu>
	);
};

export default ColumnMenu;
